import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './GradePage.css';

const Grade12Page = () => {
  return (
    <div className="grade-page">
      <Navbar />
      
      <main className="main-content">
        <div className="grade-hero" style={{ background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)' }}>
          <div className="container">
            <h1>Grade 12 Resources</h1>
            <p>Senior Secondary Level 3 CBC Curriculum Materials</p>
          </div>
        </div>
        
        <div className="container">
          <div className="page-content">
            <h2>Coming Soon - Comprehensive Grade 12 Resources</h2>
            <p>This page is under development and will contain:</p>
            
            <div className="resources-grid">
              <div className="resource-card">
                <h3>KCSE Preparation</h3>
                <p>Exam techniques and strategies</p>
              </div>
              
              <div className="resource-card">
                <h3>Past Papers</h3>
                <p>Previous years' examinations</p>
              </div>
              
              <div className="resource-card">
                <h3>Revision Materials</h3>
                <p>Comprehensive revision guides</p>
              </div>
              
              <div className="resource-card">
                <h3>Career Counseling</h3>
                <p>Post-secondary career options</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Grade12Page;